import { ProductEntity } from ".";
import { DiscountType } from "../types";

export type ProductDetailsEntity = {
  // TODO: make it number only after legacy ID is gone
  id: number | string;
  options: ProductDetailsOptionsEntity;
  categoryId: number;
  variants: ProductDetailsVariantEntity[];
};

export type ProductDetailsOptionsEntity = {
  colors: Color[];
  sizes: string[];
};

export type Color = {
  name: string;
  hex: string;
};

export type ProductDetailsVariantEntity = Omit<ProductEntity, "financials"> & {
  color?: Color;
  size?: string;
  pricingRange?: ProductPricingRangeEntity;
  stats: ProductStatsEntity;
  media: ProductMediaEntity[];
  bundle: ProductBundleItemEntity[];
  quickDetails: string;
  keywords: string[];
  howToUse: string;
  lockingRequestAvailable?: boolean;
  isFavorite?: boolean;
  financials: {
    price: number;
    profit: number;
    discounts?: DiscountEntity[];
    finalPrice: number;
    finalProfit: number;
    pricingRange?: ProductPricingRangeEntity;
  };
};

export type DiscountEntity = {
  price?: number;
  profit?: number;
  enabled?: boolean;
  expiresAt?: Date;
  type?: DiscountType;
};

export type ProductPricingRangeEntity = {
  minPrice: number;
  maxPrice: number;
};

export type ProductStatsEntity = {
  confirmationRate?: number;
  deliveryRate?: number;
};

export type ProductBundleItemEntity = {
  productId: number;
  sku: string;
  image: string;
};

export type ProductMediaEntity = {
  type: ProductMediaEntityType;
  extension: string;
  url: string;
};

export enum ProductMediaEntityType {
  IMAGE = "image",
  VIDEO = "video",
}
